export { default } from './TeaserBlockBase';

export { Label, Title, Description } from './TeaserBlockBase.styled';
